/**
 * Sanitizes a return URL to prevent open redirect attacks.
 * Only allows relative paths starting with '/' (but not '//').
 *
 * @param {string} url - The URL to sanitize.
 * @param {string} fallback - The fallback URL if validation fails. Defaults to '/'.
 * @returns {string} The sanitized URL or fallback.
 */
export function sanitizeReturnUrl(url: string | null | undefined, fallback: string = '/'): string {
    if (url?.startsWith('/') && !url.startsWith('//')) {
        return url;
    }

    return fallback;
}

